/* istanbul ignore file */
import { makeStyles } from '@material-ui/core';

export const resetTooltipStyle = makeStyles(() => ({
  tooltip: {
    backgroundColor: 'transparent',
    border: 0,
    boxShadow: 'none'
  }
}));

export const resetTooltipPadding = makeStyles(() => ({
  tooltip: {
    padding: 0
  }
}));

export const resetTooltipForMenuButton = makeStyles(() => ({
  tooltip: {
    padding: 0,
    margin: '4px 0'
  }
}));

export const increaseTooltipZIndex = makeStyles(() => ({
  popper: {
    zIndex: 1401
  }
}));

export const dicreaseTooltipMargin = makeStyles(() => ({
  tooltip: {
    marginTop: '0px'
  }
}));

export const multipleTeamsTooltip = makeStyles(() => ({
  popper: {
    marginTop: '0.3rem',
    marginLeft: '-1.1rem'
  }
}));

export const resetTooltipStyleClassesForDatePicker = makeStyles(() => ({
  tooltip: {
    padding: 0,
    margin: 0,
    border: 0,
    backgroundColor: 'white',
    transition:
      'opacity 319ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 212ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    boxShadow:
      '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12);'
  }
}));
